import { useQuery } from '@tanstack/react-query';

import { fetchCatalog } from '@/services/collections';
import type { Collection } from '@/types/collection';

export const CATALOG_QUERY_KEY = ['collections'] as const;

/**
 * collection.id совпадает со slug'ом (см. content/collections/<slug>/collection.json),
 * тем же значением, что хранится в generations.collection_id — джойн по нему.
 */
export function useCollections() {
  const query = useQuery({
    queryKey: CATALOG_QUERY_KEY,
    queryFn: fetchCatalog,
    staleTime: 5 * 60_000,
    select: (catalog) => catalog.collections,
  });

  const byId = new Map<string, Collection>((query.data ?? []).map((collection) => [collection.id, collection]));

  return { ...query, byId };
}
